
import { defineComponent, PropType, SetupContext, onMounted, ref } from "vue";
import {
  PantryFridgeAreaImageData,
  PantryFridgeRoomData,
} from "@/types/pantry";
import store from "@/store";
import PantryImageRoomItem from "./PantryImageRoomItem.vue";
import PantryImageEmptyView from "./PantryImageEmptyView.vue";
import NativeClient from "@/client/native-client";
import PantryUtil from "@/utils/pantry-util";

export default defineComponent({
  name: "PantryImageRoomView",
  components: {
    PantryImageRoomItem,
    PantryImageEmptyView
  },
  props: {
    roomId: {
      type: Number,
      defalut: -1
    },
    room: {
      type: PantryFridgeRoomData,
      default: null
    },
    imageUpdate: {
      type: Boolean,
      default: false
    },
    isSelect: {
      type: Boolean,
      default: false,
      required: true
    },
    applianceId: {
      type: String,
      default: null,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const updateDisplayKey = ref(0);
    const updateDisplay = () => {
      if (updateDisplayKey.value >= 100) {
        updateDisplayKey.value = 0;
      } else {
        updateDisplayKey.value++;
      }
    };
    const getImages = () => {
      NativeClient.sendDebugLog("PantryImageRoomView roomId=" + props.roomId);
      const areaList = new Array<PantryFridgeAreaImageData>();
      const areaIdList = PantryUtil.getAreaIdList(props.room.roomId, -1);
      if (areaIdList != null) {
        for (const id of areaIdList) {
          const areaData = props.room.areaMap.get(id);
          if (areaData != null) {
            areaList.push(areaData);
          }
        }
      }
      return areaList;
    };
    const onSelectImage = (roomId: number, areaId: number, fileName: string) => {
      context.emit("select-image", roomId, areaId, fileName);
    };
    const isEmpty = () => {
      const result = props.room && props.room.areaMap.size == 0;
      NativeClient.sendDebugLog("PantryImageRoomView isEmpty roomId=" + props.roomId + " result=" + result);
      return result;
    };
    const isNoData = () => {
      const result = props.room == null;
      NativeClient.sendDebugLog("PantryImageRoomView isNoData roomId=" + props.roomId + " result=" + result );
      return result;
    };
    const getSize = () => {
      const result = props.room ? props.room.areaMap.size : 0;
      return result;
    };
    const completeLoadCamaraImage = (roomId: number) => {
      store.dispatch("common/stopLoading");
      updateDisplay();
    };
    const setFridgeImageUrlList = async (roomId: number, applianceId: string) => {
      NativeClient.sendDebugLog("PantryImageRoomView setFridgeImageUrlList applianceId=" + applianceId + " roomId=" + roomId);
      const fridgeRoomId = PantryUtil.getFridgeRoomId(roomId);
      const success = PantryUtil.setFridgeImageUrlListMap(roomId, fridgeRoomId, applianceId);
      NativeClient.sendDebugLog("PantryImageRoomView setFridgeImageUrlList applianceId=" + applianceId + " roomId=" + roomId + " success=" + success);
      if (success) {
        const images = props.room.getImageList();
        PantryUtil.requestImageLoad(roomId, images, applianceId, completeLoadCamaraImage);
      } else {
        store.dispatch("common/stopLoading");
      }
    };
    const requestFridgeListResult = async (roomId: number, applianceId: string) => {
      setFridgeImageUrlList(roomId, applianceId);
    };
    const requestFridgeListParamResult = async (roomId: number, applianceId: string) => {
      PantryUtil.requestFridgeList(roomId, applianceId, requestFridgeListResult);
    };
    const execute = async () => {
      NativeClient.sendDebugLog("PantryImageRoomView execute roomId=" + props.roomId);
      NativeClient.sendDebugLog("PantryImageRoomView execute isSelect=" + props.isSelect);
      NativeClient.sendDebugLog("PantryImageRoomView execute images=" + JSON.stringify(props.room));
      NativeClient.sendDebugLog("PantryImageRoomView execute applianceId=" + props.applianceId);
      if (props.room && props.isSelect && props.roomId != undefined) {
        NativeClient.sendDebugLog("PantryImageRoomView execute");
        const images = props.room.getImageList();
        const isCompelete = PantryUtil.isCompeleteLoadImageData(images);
        NativeClient.sendDebugLog("PantryImageRoomView execute isCompelete=" + isCompelete);
        if (!isCompelete) {
          store.dispatch("common/startLoading");
          PantryUtil.requestFridgeListParam(props.roomId, props.applianceId, requestFridgeListParamResult)
        }
      }
    };

    const onShowDate = (roomId:number, areaId: number) => {
      const selectId = PantryUtil.getSelectId(roomId, areaId, props.room);
      const dateList = PantryUtil.getDateList(roomId, areaId, props.room);
      if (selectId != -1 && dateList.length != 0) {
        context.emit("show-date", roomId, areaId, selectId, dateList);
      }
    };

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(async () => {
      execute();
    });
    return {
      getImages,
      onSelectImage,
      isEmpty,
      isNoData,
      getSize,
      updateDisplayKey,
      onShowDate
    }
  }
});
